const PRIMED = "rq_loc_primed";

export function markPrimed() { try { localStorage.setItem(PRIMED, "1"); } catch (e) { /* storage unavailable */ } }
export function hasBeenPrimed() { try { return localStorage.getItem(PRIMED) === "1"; } catch (e) { return false; } }

// 'granted' | 'denied' | 'prompt' | 'unknown'
export async function getPermissionState() {
  if (!navigator.permissions || !navigator.permissions.query) return "unknown";
  try {
    const s = await navigator.permissions.query({ name: "geolocation" });
    return s.state;
  } catch (e) {
    return "unknown";
  }
}

export function requestPosition(opts = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) return reject(new Error("no-geolocation"));
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
      (err) => reject(err),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 10000, ...opts }
    );
  });
}
